"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = require("semantic-ui-react");

var _PanelPropietatsVisor = require("./PanelPropietatsVisor.css");

var _PanelPropietatsVisor2 = _interopRequireDefault(_PanelPropietatsVisor);

var _constants = require("../../utils/constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
//     

var PanelPropietatsVisor = function (_Component) {
	_inherits(PanelPropietatsVisor, _Component);

	function PanelPropietatsVisor() {
		_classCallCheck(this, PanelPropietatsVisor);

		var _this = _possibleConstructorReturn(this, (PanelPropietatsVisor.__proto__ || Object.getPrototypeOf(PanelPropietatsVisor)).call(this));

		_this.handleChangeVisualitzacions = function (e, _ref) {
			var value = _ref.value;
			return _this.addSelectorVisualizations("opvisual", value);
		};

		_this.state = {
			bboxValue: 1,
			tagsValue: []
		};

		return _this;
	}

	_createClass(PanelPropietatsVisor, [{
		key: "componentDidMount",
		value: function componentDidMount() {

			this.addSelectorVisualizations("opvisual", this.props.layoutOptions.opvisual);

			if (this.props.layoutOptions.tags) {
				this.setState({ tagsValue: this.props.layoutOptions.tags });
			} else {
				this.setState({ tagsValue: this.props.data.databasename });
			}
		}
	}, {
		key: "onChangeTW",
		value: function onChangeTW(checked) {
			this.updateLayoutOptions("twitter", checked);
		}
	}, {
		key: "onChangeFC",
		value: function onChangeFC(checked) {
			this.updateLayoutOptions("facebook", checked);
		}
	}, {
		key: "addSelectorVisualizations",
		value: function addSelectorVisualizations(item, value) {
			//todo add buttons
			//thematicoptions
			this.updateLayoutOptions(item, value);
		}
	}, {
		key: "updateLayoutOptions",
		value: function updateLayoutOptions(item, value) {

			this.props.updateLayoutOptions(item, value);
		}
	}, {
		key: "setTags",
		value: function setTags(item, value) {

			this.setState({ "tagsValue": value });
			this.props.updateLayoutOptions(item, value);
		}
	}, {
		key: "getTAGS",
		value: function getTAGS() {

			if (this.props.TAGSoptions && this.props.TAGSoptions.tags) {

				return this.props.TAGSoptions.tags;
			} else {

				return null;
			}
		}
	}, {
		key: "addTAGSoptions",
		value: function addTAGSoptions(value) {

			this.props.addTAGSoptions(value);
		}
	}, {
		key: "render",
		value: function render() {
			var _this2 = this;

			var hashtags = this.props.layoutOptions.hashtags;
			if (this.props.organization == "smc") {
				hashtags = hashtags.replace("EltempsTV3", "meteocat");
			}

			return _react2.default.createElement(
				_semanticUiReact.Segment,
				null,
				_react2.default.createElement(
					_semanticUiReact.Grid,
					null,
					_react2.default.createElement(
						_semanticUiReact.Grid.Row,
						{ className: _PanelPropietatsVisor2.default.row2 },
						_react2.default.createElement(
							_semanticUiReact.Grid.Column,
							{ width: 16 },
							_react2.default.createElement(
								_semanticUiReact.Form,
								null,
								_react2.default.createElement(
									_semanticUiReact.Form.Group,
									{ widths: "equal" },
									_react2.default.createElement(_semanticUiReact.Form.Input, { size: "mini",
										fluid: true,
										label: "T\xEDtol visor (en blanc, sense t\xEDtol)",
										onChange: function onChange(e, data) {
											return _this2.updateLayoutOptions("title", data.value);
										},
										value: this.props.layoutOptions.title,
										placeholder: "T\xEDtol visor" })
								),
								_react2.default.createElement(_semanticUiReact.Divider, null),
								_react2.default.createElement(
									_semanticUiReact.Form.Field,
									{ widths: "equal" },
									_react2.default.createElement(
										"label",
										null,
										"Selector zona del mapa: \xA0\xA0",
										_react2.default.createElement(_semanticUiReact.Popup, {
											size: "mini",
											className: _PanelPropietatsVisor2.default.myPopUp,
											position: "right center",
											trigger: _react2.default.createElement(_semanticUiReact.Icon, { className: _PanelPropietatsVisor2.default.iconPopup, size: "small", circular: true, fitted: true, color: "teal", name: "question" }),
											content: "Disponibles les zones dels \xFAltims 10 mapes publicats" })
									)
								),
								this.props.BBOXoptions.length > 0 && _react2.default.createElement(_semanticUiReact.Form.Dropdown, { size: "mini",
									placeholder: "zones...",
									className: _PanelPropietatsVisor2.default.smallFont,
									search: true,
									selection: true,
									onChange: this.props.updateMapview,
									options: this.props.BBOXoptions
								}),
								_react2.default.createElement(_semanticUiReact.Divider, null),
								_react2.default.createElement(
									_semanticUiReact.Form.Field,
									{ widths: "equal" },
									_react2.default.createElement(
										"label",
										null,
										"Tags del mapa: \xA0\xA0",
										_react2.default.createElement(_semanticUiReact.Popup, { size: "mini",
											className: _PanelPropietatsVisor2.default.myPopUp,
											position: "right center",
											trigger: _react2.default.createElement(_semanticUiReact.Icon, { className: _PanelPropietatsVisor2.default.iconPopup, size: "small", circular: true, fitted: true, color: "teal", name: "question" }),
											content: "Ajuden a classificar i cercar els mapes" })
									)
								),
								_react2.default.createElement(_semanticUiReact.Form.Dropdown, {
									placeholder: "Tags...",
									className: _PanelPropietatsVisor2.default.smallFont,
									size: "mini",
									search: true,
									fluid: true,
									selection: true,
									additionLabel: "Afegir ",
									multiple: true,
									value: this.state.tagsValue,
									allowAdditions: true,
									onChange: function onChange(e, data) {
										return _this2.setTags("tags", data.value);
									},
									onAddItem: function onAddItem(e, data) {
										return _this2.addTAGSoptions(data.value);
									},
									options: this.props.TAGSoptions.tags
								}),
								"Hashtags",
								_react2.default.createElement(_semanticUiReact.Divider, null),
								_react2.default.createElement(
									_semanticUiReact.Form.Field,
									{ widths: "equal" },
									_react2.default.createElement(
										"label",
										null,
										"Selector de visualitzacions:"
									)
								),
								_react2.default.createElement(
									_semanticUiReact.Form.Group,
									{ inline: true },
									_react2.default.createElement(_semanticUiReact.Form.Radio, {
										label: "en Blanc",
										value: _constants.BUTTONS_TYPE_BLANC,
										checked: this.props.layoutOptions.opvisual === _constants.BUTTONS_TYPE_BLANC,
										onChange: this.handleChangeVisualitzacions
									}),
									_react2.default.createElement(_semanticUiReact.Form.Radio, {
										label: "Icones",
										value: _constants.BUTTONS_TYPE_ICONES,
										checked: this.props.layoutOptions.opvisual === _constants.BUTTONS_TYPE_ICONES,
										onChange: this.handleChangeVisualitzacions
									})
								),
								_react2.default.createElement(
									_semanticUiReact.Form.Group,
									{ inline: true },
									_react2.default.createElement(_semanticUiReact.Form.Radio, {
										label: "Text",
										value: _constants.BUTTONS_TYPE_TEXT,
										checked: this.props.layoutOptions.opvisual === _constants.BUTTONS_TYPE_TEXT,
										onChange: this.handleChangeVisualitzacions
									}),
									_react2.default.createElement(_semanticUiReact.Form.Radio, {
										label: "Icones + Text",
										value: _constants.BUTTONS_TYPE_ICONESTEXT,
										checked: this.props.layoutOptions.opvisual === _constants.BUTTONS_TYPE_ICONESTEXT,
										onChange: this.handleChangeVisualitzacions
									})
								),
								_react2.default.createElement(_semanticUiReact.Divider, null),
								_react2.default.createElement(
									_semanticUiReact.Form.Field,
									{ widths: "equal" },
									_react2.default.createElement(
										"label",
										null,
										"Icones xarxes socials:"
									)
								),
								_react2.default.createElement(
									_semanticUiReact.Form.Group,
									{ inline: true },
									_react2.default.createElement(_semanticUiReact.Form.Checkbox, {
										checked: this.props.layoutOptions.twitter,
										label: _react2.default.createElement(
											"label",
											null,
											_react2.default.createElement(_semanticUiReact.Icon, { name: "twitter" }),
											"Twitter"
										),
										onChange: function onChange(e, data) {
											return _this2.onChangeTW(data.checked);
										}

									}),
									_react2.default.createElement(_semanticUiReact.Form.Checkbox, {
										label: _react2.default.createElement(
											"label",
											null,
											_react2.default.createElement(_semanticUiReact.Icon, { name: "facebook" }),
											"Facebook"
										),
										checked: this.props.layoutOptions.facebook,
										onChange: function onChange(e, data) {
											return _this2.onChangeFC(data.checked);
										}
									})
								),
								_react2.default.createElement(
									_semanticUiReact.Form.Group,
									{ style: { display: this.props.layoutOptions.twitter ? "block" : "none" }, widths: "equal" },
									_react2.default.createElement(_semanticUiReact.Form.Input, { size: "mini",
										fluid: true,
										label: "Hashtags, separats coma",
										onChange: function onChange(e, data) {
											return _this2.updateLayoutOptions("hashtags", data.value);
										},
										value: hashtags,
										placeholder: "hashtags" })
								)
							)
						)
					)
				)
			);
		}
	}]);

	return PanelPropietatsVisor;
}(_react.Component);

exports.default = PanelPropietatsVisor;


PanelPropietatsVisor.propTypes = {
	layoutOptions: _propTypes2.default.object,
	thematicoptions: _propTypes2.default.array,
	data: _propTypes2.default.object,
	onChange: _propTypes2.default.func,
	updateLayoutOptions: _propTypes2.default.func,
	addTAGSoptions: _propTypes2.default.func,
	removeViz: _propTypes2.default.func,
	BBOXoptions: _propTypes2.default.arrayOf(_propTypes2.default.object),
	TAGoptions: _propTypes2.default.array,
	updateMapview: _propTypes2.default.func,
	organization: _propTypes2.default.string
};
